const USER_DETAILS_MAPPER = {
  id: { key: 'id', label: 'ID', sideBarLabel: 'User ID' },
  internalId: {
    key: 'internalId',
    label: 'Internal ID',
    sideBarLabel: 'Internal ID',
  },
  firstName: {
    key: 'firstName',
    label: 'First Name',
    sideBarLabel: 'First Name',
  },
  lastName: {
    key: 'lastName',
    label: 'Last Name',
    sideBarLabel: 'Last Name',
  },
  addressName: {
    key: 'addressName',
    label: 'Address Name',
    sideBarLabel: 'Address Name',
  },
  email: { key: 'email', label: 'Email', sideBarLabel: 'Contact Information' },
  phoneNumber: {
    key: 'phoneNumber',
    label: 'Phone Number',
    sideBarLabel: 'Phone',
  },
  dateOfBirth: {
    key: 'dateOfBirth',
    label: 'Date of Birth',
    sideBarLabel: 'Date of Birth',
  },
  driversLicenseNumber: {
    key: 'driversLicenseNumber',
    label: 'Drivers License Number',
    sideBarLabel: 'License Number',
  },
  driversLicenseIssueDate: {
    key: 'driversLicenseIssueDate',
    label: 'Drivers License Issue Date',
    sideBarLabel: 'Issue date of license',
  },
  lang: {
    key: 'lang',
    label: 'Language',
    sideBarLabel: 'Language',
    options: [
      {
        label: 'English',
        value: 'en',
        icon: '🇬🇧',
      },
      {
        label: 'Greek',
        value: 'el',
        icon: '🇬🇷',
      },
    ],
  },
  createdAt: {
    key: 'createdAt',
    label: 'Created At',
    sideBarLabel: 'Created At',
  },
  updatedAt: {
    key: 'updatedAt',
    label: 'Updated At',
    sideBarLabel: 'Updated At',
  },
};

const USER_DETAILS_TITLE = 'User Information';

export { USER_DETAILS_MAPPER, USER_DETAILS_TITLE };
